import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue";

import { useWindowScroll, useElementBounding } from '@vueuse/core';
import { ref, nextTick, watch } from 'vue';
var _hoisted_1 = ["innerHTML"];
export default {
  __name: 'Tooltip',
  props: {
    text: {
      type: String,
      "default": ""
    },
    maxWidth: {
      type: Number,
      "default": 0
    },
    persistent: Boolean,
    tooltipClass: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    tooltipStyle: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    visible: Boolean
  },
  setup: function setup(__props) {
    var props = __props;
    var _useWindowScroll = useWindowScroll(),
      y = _useWindowScroll.y;
    var isVisible = ref(false);
    var container = ref(document.querySelector("body"));
    var tooltipRef = ref(null);
    var tooltipWrapperRef = ref(null);
    var positionX = ref(0);
    var positionY = ref(0);
    var opacity = ref(0);
    var _useElementBounding = useElementBounding(container),
      windowLeft = _useElementBounding.left,
      windowRight = _useElementBounding.right;
    var timeout;
    var isHitRight = ref(false);
    function onHover() {
      return _onHover.apply(this, arguments);
    }
    function _onHover() {
      _onHover = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _useElementBounding2, tooltipWrapperLeft, tooltipWrapperTop, tooltipWrapperBottom, tooltipWrapperWidth, _useElementBounding3, tooltipWidth, tooltipHeight, isHitLeft, isHitTop;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isVisible.value = true;
              _context.next = 3;
              return nextTick();
            case 3:
              _useElementBounding2 = useElementBounding(tooltipWrapperRef), tooltipWrapperLeft = _useElementBounding2.left, tooltipWrapperTop = _useElementBounding2.top, tooltipWrapperBottom = _useElementBounding2.bottom, tooltipWrapperWidth = _useElementBounding2.width;
              _useElementBounding3 = useElementBounding(tooltipRef), tooltipWidth = _useElementBounding3.width, tooltipHeight = _useElementBounding3.height;
              positionX.value = tooltipWrapperLeft.value + tooltipWrapperWidth.value / 2 - tooltipWidth.value / 2;
              positionY.value = tooltipWrapperTop.value - tooltipHeight.value - 8;
              isHitLeft = positionX.value <= windowLeft.value;
              isHitTop = positionY.value <= 0;
              isHitRight.value = positionX.value + tooltipWidth.value >= windowRight.value;
              if (isHitLeft) {
                positionX.value = 5;
              }
              if (isHitTop) {
                positionY.value = tooltipWrapperBottom.value + 8;
              }
              opacity.value = 1;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onHover.apply(this, arguments);
    }
    function onPersistentHover() {
      if (!props.persistent) {
        return;
      }
      clearTimeout(timeout);
      isVisible.value = true;
    }
    function onPersistentOut() {
      if (!props.persistent) {
        return;
      }
      clearTimeout(timeout);
      isVisible.value = false;
    }
    function onLeave() {
      if (props.persistent) {
        timeout = setTimeout(function () {
          return isVisible.value = false;
        }, 100);
        return;
      }
      clearTimeout(timeout);
      isVisible.value = false;
    }
    watch(function () {
      return props.text;
    }, function (value, old) {
      if (value === old || isVisible.value === false) {
        return;
      }
      onHover();
    });
    watch(function () {
      return props.visible;
    }, function (value) {
      value ? onHover() : onLeave();
    });
    watch(y, onLeave);
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "tooltipWrapperRef",
        ref: tooltipWrapperRef,
        "class": "inline-flex",
        onMouseenter: onHover,
        onMouseleave: onLeave
      }, [_renderSlot(_ctx.$slots, "default"), (_openBlock(), _createBlock(_Teleport, {
        to: "#tooltips"
      }, [_unref(isVisible) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "tooltipRef",
        ref: tooltipRef,
        "class": _normalizeClass(["fixed shadow-lg px-md py-md text-sm rounded-md leading-[1.4] z-[20001] text-white bg-secondary border border-solid border-zinc-700", __props.tooltipClass]),
        style: _normalizeStyle(_objectSpread({
          left: _unref(isHitRight) ? 'auto' : "".concat(_unref(positionX), "px"),
          right: _unref(isHitRight) ? '5px' : 'auto',
          top: "".concat(_unref(positionY), "px"),
          maxWidth: __props.maxWidth ? "".concat(__props.maxWidth, "px") : 'auto',
          opacity: _unref(opacity)
        }, __props.tooltipStyle)),
        onMouseover: onPersistentHover,
        onMouseleave: onPersistentOut
      }, [__props.text ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        innerHTML: __props.text
      }, null, 8, _hoisted_1)) : _renderSlot(_ctx.$slots, "text", {
        key: 1
      })], 38)) : _createCommentVNode("", true)]))], 544);
    };
  }
};